import { ref, onMounted, onUpdated, onBeforeUnmount, nextTick } from 'vue'

const pendingFocusRestore = {}

export const useFocusRestore = (key, options = {}) => {
  const rootRef = ref(null)
  const hasInnerFocus = ref(false)

  const restoreInnerFocus = () => {
    nextTick(() => {
      const input = rootRef.value?.querySelector('.dx-texteditor-input')
      if (input && document.activeElement !== input) { input.focus() }
    })
  }

  const onFocusIn = () => { hasInnerFocus.value = true }

  const onFocusOut = (e) => {
    if (e.relatedTarget && rootRef.value && !rootRef.value.contains(e.relatedTarget)) {
      hasInnerFocus.value = false
    }
  }

  if (options.trackInnerFocus) {
    onUpdated(() => {
      if (hasInnerFocus.value && rootRef.value && !rootRef.value.contains(document.activeElement)) {
        restoreInnerFocus()
      }
    })
  }

  if (key) {
    onBeforeUnmount(() => {
      const isFocusedInside = options.trackInnerFocus ? hasInnerFocus.value : !!rootRef.value?.contains(document.activeElement)
      if (isFocusedInside) { pendingFocusRestore[key] = true }
    })

    onMounted(() => {
      if (pendingFocusRestore[key]) {
        pendingFocusRestore[key] = false
        restoreInnerFocus()
      }
    })
  }

  return { rootRef, restoreInnerFocus, onFocusIn, onFocusOut }
}
